import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from "react";

import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import FunilPermanencia from './pages/FunilPermanencia';
import Enade from './pages/Enade';
import OtimizacaoFinanceira from './pages/OtimizacaoFinanceira';
import Contato from './pages/Contato';
import Sobre from './pages/Sobre';
import Faq from './pages/Faq';
import Privacidade from './pages/Privacidade';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/funil" element={<FunilPermanencia />} />
        <Route path="/enade" element={<Enade />} />
        <Route path="/financeiro" element={<OtimizacaoFinanceira />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacidade" element={<Privacidade />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
